export default __webpack_public_path__ + "static/media/information-icon.f9cc1959.svg";